module.exports = __webpack_public_path__ + "static/media/TestTypeTwo.fa37cec6.svg";